import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import ErrorLog from './components/ErrorLog';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/error-log" element={<ErrorLog />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

